import * as React from 'react';

import { Icon } from '@base/components/Icon';

import { IconMailik } from '@icons';

import * as s from './TopMenuBalance.scss';

interface ITopMenuBalanceProps {
	balance: number;
}

export const TopMenuBalance = (props: ITopMenuBalanceProps) => {
	const { balance } = props;

	return <div className={s.block}>
		<Icon
			className={s.icon}
			glyph={IconMailik}
		/>
		<span className={s.balance}>{balance}</span>
	</div>;
};
